<!--工作室课程-->
<template>
    <div class="studio_nav_content">
        <!--列表模式-->
        <div class="page-mode" v-show="showMode==='page'">
            <div class="left-container">
                <div class="nav-container">
                    <div class="nav-title">
                        {{title}}
                    </div>
                    <div class="nav-list">
                        <div class="type-active" >>{{title}}</div>
                    </div>
                </div>
            </div>

            <div class="right-container">
                <div class="page-info-container">
                    <div class="info-top-title">
                        <div class="title">{{title}}</div>
                    </div>
                    <div class="info-list-container">
                        <div class="course-list-box">
                            <div class="course-item" v-for="item in dataList" :key="item">
                                <div class="course-one" @click="viewCourse(item)">
                                    <div class="course-cover">
                                        <img class="img-100" :src="item.courseCover" alt />
                                    </div>
                                    <div class="course-name">{{item.courseName}}</div>
                                </div>
                            </div>
                        </div>
                        <data-empty v-if="dataList&&dataList.length===0" title="暂无数据"/>
                    </div>
                    <div class="page-container" v-if="dataList&&dataList.length>0">
                        <pageTag :background="true"
                                 :pageSizes="[8, 12, 16]"
                                 v-show="total > 0"
                                 :total="total"
                                 v-model:page.sync="queryParams.pageNum"
                                 v-model:limit.sync="queryParams.pageSize"
                                 @pagination="pageCourse" />
                    </div>
                </div>
            </div>
        </div>
        <!--详情模式-->
        <div class="detail-mode" v-show="showMode==='detail'">
            <course-info-xb :course-id="this.courseId" :classify="courseType"  @change-mode="changeModel"/>
        </div>
    </div>
</template>

<script>
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import courseInfoXb from "@/components/course/courseInfoXb.vue";
import {timestampDate} from "@/utils/date";
import {famousCoursePageFamousCourses} from "@/api/admin/famousCourse";

export default {
    name:'studioCourseXb',
    components:{pageTag, dataEmpty,courseInfoXb},
    props:{
        studioId:{
            type: String,
            default:null
        },
        title:{
            type: String,
            default:null
        },
        courseType:{
            type: String,
            default:null
        },
        courseMode:{
            type: String,
            default:'page'
        },
        parentId:{
            type: String,
            default:''
        }
    },
    watch:{
        courseMode(newValue,oldValue){
            this.showMode = newValue;
        },
        parentId(newValue,oldValue){
            this.courseId = newValue;
        },
    },
    mounted() {
        this.pageCourse();
    },
    data() {
        return {
            showMode:'page',
            timestampDate,
            itemName:'高水平示范课',
            itemKey:'',
            queryParams: {
                pageNum: 1,
                pageSize: 8,
                stageType: '',
                groupId: '',
            },
            total: 0,
            pageCount:0,
            dataList: [],
            studioClassifyList:[],
            courseId:'',
        }
    },
    methods: {
        pageCourse(){
            this.queryParams.stageType = this.courseType;
            this.queryParams.groupId = this.studioId
            famousCoursePageFamousCourses(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.dataList = res.data.data.list;
                    this.total = res.data.data.total;
                    this.pageCount = res.data.data.totalPage;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        viewCourse(item){
            this.showMode = "detail"
            this.courseId = item.courseId;
        },
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode, 8);
        }
    }
}

</script>

<style scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
}
.page-mode{
    display: flex;
    width: 100%;
    height: auto;
}
.left-container{
    width: 200px;
    height: 200px;
    padding-bottom: 20px;
    box-sizing: border-box;
}
.nav-container{
    width: 180px;
    height: 100px;
    background: #fff;
}
.nav-title{
    width: 100%;
    height: 32px;
    background-color: #ff7f2e;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 16px;
    margin-bottom: 10px;
}
.nav-list{
    width: 180px;
    height: auto;
    background: #fff;
    padding-bottom: 10px;
}
.type-active{
    width: 100%;
    height: 24px;
    line-height: 24px;
    font-size: 15px;
    text-align: center;
    cursor: pointer;
    color: #ff7f2e;
    font-weight: bold;
}
.menu-item{
    width: 100%;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    color: #333333;
    font-family: "Microsoft JhengHei",sans-serif;
    font-weight: bold;
}
.is-active{
    color: #ff7f2e!important;
}

.right-container{
    width: calc(100% - 200px);
    height: auto;
}
.page-info-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    background-color: #fff;
}
.info-top-title{
    width: 99%;
    height: 34px;
    margin: auto;
    line-height: 30px;
    font-size: 16px;
    font-weight: 400;
    display: flex;
    flex-direction: column;
}
.title{
    padding-right: 10px;
    border-bottom: 2px solid #ff7f2e;
}

.info-list-container{
    width: 100%;
    height: auto;
    margin: auto;
    overflow-x: hidden;
}
/*课程*/
.course-list-box{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    padding: 10px 10px 0 10px;
    align-items: center;
    box-sizing: border-box;
}
.course-item{
    width: 25%!important;
    height: 170px;
    padding-right: 10px;
    box-sizing: border-box;
    cursor: pointer;
}
.course-one{
    width: 100%;
    height: 140px;
    border: 1px solid #cecece;
    border-radius: 4px;
    box-sizing: border-box;
}
.course-cover{
    width: 100%;
    height: 100%;
    img{
        width: 100%;
        height: 100%;
    }
}
.course-name{
    height: 30px;
    font-size: 16px;
    color: #333333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 30px;
}
.page-container{
    display: grid;
    place-items: center;
    width: 98%;
    height: 40px;
    margin-top: 10px;
}
.detail-mode{
    width: 100%;
    height: auto;
}
</style>